unit stfmssystem.login;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, XData.Web.Client, Data.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Buttons, WEBLib.ExtCtrls,
  Vcl.Grids, WEBLib.DBCtrls, WEBLib.DB, WEBLib.WebCtrls,
  WEBLib.TMSWEBCustomComponent, WEBLib.TMSWEBStateManager,
  WEBLib.TMSWEBResponsiveManager;

type
  Tfrmlogin = class(TForm)
    MessageDlg: TMessageDlg;
    webconnect: TXDataWebClient;
    wpLogin: TPanel;
    lUsername: TLabel;
    lPassword: TLabel;
    weUsername: TEdit;
    wePassword: TEdit;
    wbtLogin: TSpeedButton;
    procedure wbtLoginClick(Sender: TObject);
    procedure wePasswordKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure weUsernameKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
  private
    { Private declarations }
    procedure LoadData;
  public
    { Public declarations }
    slnCodeLogin : string;
  protected procedure LoadDFMValues; override; end;

var
  frmlogin: Tfrmlogin;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  stfmssystem.main,
  share.classes,
  share.common;

procedure Tfrmlogin.LoadData;
  var
    LoginUser : TLoginUser;
  procedure OnError (Error: TXDataClientError);
  begin
    LoadData;
  end;
  procedure OnResult (Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) and (Response.StatusCode > 299) then
      begin
        LoadData;
      end
    else
      begin
        TAppSession.CurrentUser := LoginUser.UserName;
        LoginUser.Free;
        dmdata.sToken := JS.ToString(JS.ToObject(Response.Result)['value']);
        dmdata.LStorage.setvalue(stfmssystem.connection.TokenName, dmdata.sToken);
        dmdata.LStorage.setvalue(stfmssystem.connection.Username, weUsername.Text);
        Close;
      end;
  end;
begin
  LoginUser := TLoginUser.Create;
  LoginUser.UserName := weUsername.Text;
  LoginUser.Password := wePassword.Text;
  LoginUser.SystemType := 0;
  webConnect.RawInvoke('ILoginService.Login', [ConvertObjToJson(LoginUser).ToString],@OnResult,@OnError);

  //LoginUser.Free;
end;

procedure Tfrmlogin.wbtLoginClick(Sender: TObject);
begin
  dmdata.sToken := '';
  LoadData;
end;

procedure Tfrmlogin.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Action := caFree;
end;

procedure Tfrmlogin.wePasswordKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
 If Key = VK_Return Then
  begin
    wbtLoginClick(Self);
  end;
end;

procedure Tfrmlogin.weUsernameKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Return then
    begin
      wePassword.SetFocus;
    end;
end;

procedure Tfrmlogin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MessageDlg := TMessageDlg.Create(Self);
  wpLogin := TPanel.Create(Self);
  lUsername := TLabel.Create('subs.login.lUsername');
  lPassword := TLabel.Create('subs.login.lPassword');
  weUsername := TEdit.Create('subs.login.weUsername');
  wePassword := TEdit.Create('subs.login.wePassword');
  wbtLogin := TSpeedButton.Create('subs.login.wbtLogin');
  webconnect := TXDataWebClient.Create(Self);

  MessageDlg.BeforeLoadDFMValues;
  wpLogin.BeforeLoadDFMValues;
  lUsername.BeforeLoadDFMValues;
  lPassword.BeforeLoadDFMValues;
  weUsername.BeforeLoadDFMValues;
  wePassword.BeforeLoadDFMValues;
  wbtLogin.BeforeLoadDFMValues;
  webconnect.BeforeLoadDFMValues;
  try
    Name := 'frmlogin';
    Width := 299;
    Height := 207;
    Caption := 'STFMS - Sub-Contractor Login';
    Color := clSilver;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    MessageDlg.SetParentComponent(Self);
    MessageDlg.Name := 'MessageDlg';
    MessageDlg.Left := 160;
    MessageDlg.Top := 69;
    MessageDlg.Width := 24;
    MessageDlg.Height := 24;
    MessageDlg.Buttons := [mbOK];
    MessageDlg.Opacity := 0.200000000000000000;
    MessageDlg.ElementButtonClassName := 'btn';
    MessageDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MessageDlg.ElementTitleClassName := 'text-body';
    MessageDlg.ElementContentClassName := 'text-body';
    wpLogin.SetParentComponent(Self);
    wpLogin.Name := 'wpLogin';
    wpLogin.Left := 0;
    wpLogin.Top := 0;
    wpLogin.Width := 299;
    wpLogin.Height := 207;
    wpLogin.Center.Horizontal := True;
    wpLogin.Center.Vertical := True;
    wpLogin.Align := alClient;
    wpLogin.BorderColor := clBlack;
    wpLogin.BorderStyle := bsNone;
    wpLogin.ChildOrder := 5;
    wpLogin.Color := clSilver;
    wpLogin.TabOrder := 1;
    lUsername.SetParentComponent(wpLogin);
    lUsername.Name := 'lUsername';
    lUsername.Left := 40;
    lUsername.Top := 5;
    lUsername.Width := 82;
    lUsername.Height := 18;
    lUsername.Caption := 'Username : ';
    lUsername.ElementFont := efCSS;
    lUsername.HeightStyle := ssAuto;
    lUsername.HeightPercent := 100.000000000000000000;
    lUsername.WidthPercent := 100.000000000000000000;
    lPassword.SetParentComponent(wpLogin);
    lPassword.Name := 'lPassword';
    lPassword.Left := 40;
    lPassword.Top := 65;
    lPassword.Width := 71;
    lPassword.Height := 18;
    lPassword.Caption := 'Password :';
    lPassword.ElementFont := efCSS;
    lPassword.HeightStyle := ssAuto;
    lPassword.HeightPercent := 100.000000000000000000;
    lPassword.WidthPercent := 100.000000000000000000;
    weUsername.SetParentComponent(wpLogin);
    weUsername.Name := 'weUsername';
    weUsername.Left := 40;
    weUsername.Top := 31;
    weUsername.Width := 177;
    weUsername.Height := 23;
    weUsername.AutoCompletion := acUserName;
    weUsername.CharCase := wecUpperCase;
    weUsername.ChildOrder := 1;
    weUsername.ElementClassName := 'form-control';
    weUsername.HeightStyle := ssAuto;
    weUsername.HeightPercent := 100.000000000000000000;
    weUsername.WidthPercent := 100.000000000000000000;
    SetEvent(weUsername, Self, 'OnKeyDown', 'weUsernameKeyDown');
    wePassword.SetParentComponent(wpLogin);
    wePassword.Name := 'wePassword';
    wePassword.Left := 40;
    wePassword.Top := 92;
    wePassword.Width := 177;
    wePassword.Height := 22;
    wePassword.AutoCompletion := acCurrentPassword;
    wePassword.ChildOrder := 3;
    wePassword.ElementClassName := 'form-control';
    wePassword.HeightStyle := ssAuto;
    wePassword.HeightPercent := 100.000000000000000000;
    wePassword.PasswordChar := '*';
    wePassword.WidthPercent := 100.000000000000000000;
    SetEvent(wePassword, Self, 'OnKeyDown', 'wePasswordKeyDown');
    wbtLogin.SetParentComponent(wpLogin);
    wbtLogin.Name := 'wbtLogin';
    wbtLogin.Left := 51;
    wbtLogin.Top := 144;
    wbtLogin.Width := 154;
    wbtLogin.Height := 24;
    wbtLogin.Caption := 'Login';
    wbtLogin.Color := clNone;
    wbtLogin.ElementClassName := 'btn btn-primary';
    wbtLogin.HeightStyle := ssAuto;
    wbtLogin.HeightPercent := 100.000000000000000000;
    wbtLogin.MaterialGlyph := 'lock';
    wbtLogin.TabOrder := 2;
    wbtLogin.WidthPercent := 100.000000000000000000;
    SetEvent(wbtLogin, Self, 'OnClick', 'wbtLoginClick');
    webconnect.SetParentComponent(Self);
    webconnect.Name := 'webconnect';
    webconnect.Connection := dmData.dbConnect;
    webconnect.Left := 8;
    webconnect.Top := 33;
  finally
    MessageDlg.AfterLoadDFMValues;
    wpLogin.AfterLoadDFMValues;
    lUsername.AfterLoadDFMValues;
    lPassword.AfterLoadDFMValues;
    weUsername.AfterLoadDFMValues;
    wePassword.AfterLoadDFMValues;
    wbtLogin.AfterLoadDFMValues;
    webconnect.AfterLoadDFMValues;
  end;
end;

end.
